export default "__VITE_ASSET__DyzfwQY___"